export default "__VITE_ASSET__TBaDkbOh__"